import { TreeItemType } from '@api';
import { TreeInstance } from '@headless-tree/core';
import { Center, Group, Loader, Stack, Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AddTreeItemMenu, TreeHeader, TreeItem } from './components';

type FileTreePropsType = {
  rootFolderId: string;
  tree: TreeInstance<TreeItemType>;
  isFetching: boolean;
  canWrite: boolean;
  onDeleteItem: (item: TreeItemType) => void;
  onCreateFolder: (folderName: string) => void;
  onAddFile: (parentFolderId: string) => void;
};

export const FileTree: React.FC<FileTreePropsType> = ({
  rootFolderId,
  tree,
  isFetching,
  canWrite,
  onDeleteItem,
  onCreateFolder,
  onAddFile,
}) => {
  const { t } = useTranslation();
  const items = tree.getItems();
  const isEmpty = items.length === 0;

  return (
    <Stack>
      <Group h="20px" justify="end">
        {isFetching && <Loader size="xs" />}
        {canWrite && (
          <AddTreeItemMenu
            onAddFolder={() => onCreateFolder(rootFolderId)}
            onAddFile={() => onAddFile(rootFolderId)}
          />
        )}
      </Group>
      <Table>
        <TreeHeader />
        <Table.Tbody {...tree.getContainerProps()}>
          {isEmpty ? (
            <Table.Tr>
              <Table.Td colSpan={5}>
                <Center>
                  <Text c="dimmed" py="md" data-testid="file-tree-empty">
                    {t('FILE_TREE.EMPTY_STATE.MESSAGE')}
                  </Text>
                </Center>
              </Table.Td>
            </Table.Tr>
          ) : (
            items.map((item) => (
              <TreeItem
                item={item}
                key={item.getId()}
                canWrite={canWrite}
                onDelete={onDeleteItem}
                onAddFolder={onCreateFolder}
                onAddFile={onAddFile}
              />
            ))
          )}
        </Table.Tbody>
      </Table>
    </Stack>
  );
};
